// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18s8ze3t{margin:var(--ds-space-0,0)}
._1yt4ze3t{padding:var(--ds-space-0,0)}
._1e0c1txw{display:flex}
._1n261g80{flex-wrap:wrap}
._syazpsu8{color:var(--_vrm7dk)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/breadcrumbs/dist/esm/components/breadcrumbs.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0BAA0B;AACrC,WAAW,2BAA2B;AACtC,WAAW,YAAY;AACvB,WAAW,cAAc;AACzB,WAAW,oBAAoB","sourcesContent":["._18s8ze3t{margin:var(--ds-space-0,0)}\n._1yt4ze3t{padding:var(--ds-space-0,0)}\n._1e0c1txw{display:flex}\n._1n261g80{flex-wrap:wrap}\n._syazpsu8{color:var(--_vrm7dk)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
